import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=25dcf5a1&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
import style0 from "./Tab.vue?vue&type=style&index=0&id=25dcf5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dcf5a1",
  null
  
)

export default component.exports